import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=d4cc279e&"
import script from "./Prescriptions.vue?vue&type=script&lang=js&"
export * from "./Prescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports